import GitLabSettingsDialog from "@/components/dialogs/GitLabSettingsDialog.vue";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useDialog } from "primevue/usedialog";
import { computed, ref } from "vue";

export const useGitLabSettingsDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();

    const open = () => {
        dialogRef.value = dialog.open(GitLabSettingsDialog, {
            props: {
                header: "GitLab Integration Settings",
                style: {
                    maxWidth: "500px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            onClose: () => {
                dialogRef.value = undefined;
            },
        });
    };

    return {
        open,
        isVisible: computed(() => Boolean(dialogRef.value?.visible)),
    };
};
